import {
  configureApiClient,
  createDefaultStorage,
  SessionStore,
} from "@brad-tipper/app-frontend";

import { API_URL } from "~/lib/constants";
import { client } from "./generated/client.gen";

export const sessionStore = new SessionStore({
  baseUrl: API_URL,
  storage: createDefaultStorage(),
  key: "durance.session",
});

configureApiClient({ client, baseUrl: API_URL, session: sessionStore });

export { client };
export * as api from "./generated/sdk.gen";
